export default __webpack_public_path__ + "static/bg_image_other@2x-eaca6c54b83287737a366a19dd31d420.png";